import _flowRight from 'lodash/flowRight';
import _uniqueId from 'lodash/uniqueId';
import { normalize } from 'normalizr';
// import { getPRWorkOrder } from '@homeservices/api-kit/workorder/proreferral';
import { getMatches } from '@homeservices/api-kit/workorder/proreferral';

import { PRO_WORK_ORDERS_SCHEMA } from '@/store/modules/entities';
import { withTakeLatest } from '@/utils/cancel-token';
import {
  withRequestLifecycle,
  REQUEST_LIFECYCLE,
} from '@/utils/request-lifecycle';

const MUTATION_KEY = 'patchWorkOrderMatches';
const emptyArray = [];
const initialPartialState = {

  status: REQUEST_LIFECYCLE.UNINITIALIZED,
  error: null,
  result: emptyArray,
  count: 0,
  total: 0,
  hasMore: false,

};

export default {
  namespaced: true,
  state: {
    workOrdersMatchesKey: _uniqueId(),
  },
  getters: {
    workOrdersMatchesKey: state => state.workOrdersMatchesKey,
    getJobsMetaByStatusAlias: state => (jobsStatusAlias) => {
      const { result, ...meta } = state[jobsStatusAlias] || initialPartialState;

      return meta;
    },
    getRawJobsByStatusAlias: state => jobsStatusAlias =>
      (state[jobsStatusAlias] || initialPartialState).result,
  },
  actions: {
    fetchWorkOrderMatches: _flowRight(
      withTakeLatest('jobsStatusAlias'),
      withRequestLifecycle(MUTATION_KEY),
      () => async (
        { dispatch, rootGetters },
        { injected: { performFulfillment },
          params = {},
        }

      ) => {
        const { data: { results, total } } = await getMatches(params);
        const jobHashs = results.reduce((acc, cur) => {
          acc.push(cur.work_order_info.order_hash);
          return acc;
        }, []);
        if (jobHashs.length) {
          const [serviceProviderId] = rootGetters['account/pro/serviceProvidersIds'];
          const chunkSize = 50;
          const jobHashsChunks = jobHashs.reduce((resultArray, jobHash, index) => {
            const chunkIndex = Math.floor(index / chunkSize);
            if (!resultArray[chunkIndex]) {
              resultArray[chunkIndex] = []; // eslint-disable-line no-param-reassign
            }
            resultArray[chunkIndex].push(jobHash);
            return resultArray;
          }, []);
          await jobHashsChunks.forEach((chunk) => {
            dispatch(
              'dashboard/appointments/fetchAppointments',
              {
                params: { order_hash: chunk.join(','), service_provider_id: serviceProviderId, size: 100 },
              },
              { root: true }
            );
          });
        }

        const workOrders = results.map((wo) => {
          const orders = Object.assign({}, wo.work_order_info);
          const matches = Object.assign({}, wo);
          delete matches.work_order_info;
          return {
            ...orders,
            matches,
          };
        });

        const { result, entities } = normalize(workOrders, [PRO_WORK_ORDERS_SCHEMA]);

        return performFulfillment({
          total,
          result,
          entities,
        });
      }
    )(),
    resetWorkOrderMatches: ({ commit }, { jobsStatusAlias }) => {
      commit('resetWorkOrderMatches', { meta: { jobsStatusAlias } });
    },
  },
  mutations: {
    [MUTATION_KEY] (state, payload) {
      const { jobsStatusAlias } = payload.meta;
      const partialState = state[jobsStatusAlias] || initialPartialState;
      const result = [...new Set([...partialState.result, ...(payload.result || emptyArray)])];

      state[jobsStatusAlias] = {
        ...partialState,
        ...payload,
        result,
        count: result.length,
        hasMore: result.length < payload.total,
      };

      state.workOrdersMatchesKey = _uniqueId();
    },
    resetWorkOrderMatches (state, { meta }) {
      const { jobsStatusAlias } = meta;

      state[jobsStatusAlias] = initialPartialState;
      state[jobsStatusAlias].meta = meta;

      state.workOrdersMatchesKey = _uniqueId();
    },
    transitionJob (state, { meta }) {
      const { from, to, order_hash: jobId } = meta;
      const fromPartialState = state[from] || initialPartialState;
      const fromResult = fromPartialState.result.filter(fromJobId => fromJobId !== jobId);
      const fromNewTotal = Math.max(fromPartialState.total - 1, 0);
      const toPartialState = state[to] || initialPartialState;
      const toResult = [...new Set([jobId, ...toPartialState.result])];
      const toNewTotal = toPartialState.total + 1;

      state[from] = {
        ...fromPartialState,
        meta,
        status: 'mutated',
        result: fromResult,
        count: fromResult.length,
        total: fromNewTotal,
        hasMore: fromResult.length < fromNewTotal,
      };

      if (to) {
        state[to] = {
          ...toPartialState,
          meta,
          status: 'mutated',
          result: toResult,
          count: toResult.length,
          total: toNewTotal,
          hasMore: toResult.length < toNewTotal,
        };
      }

      state.workOrdersMatchesKey = _uniqueId();
    },
  },
};
